import React, { useCallback, useEffect, useState } from "react";
import {
  Button,
  Form,
  Modal,
  Card,
  message,
  Spin,
  Space,
  Image,
  Row,
  Col,
  Divider,
  Empty,
  Tag,
  Table,
} from "antd";
import {
  FilePdfOutlined,
  FileSearchOutlined,
  HomeOutlined,
  CarOutlined,
  EyeOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import axios from "axios";
import dayjs from "dayjs";
import {
  GET_LOAD_IMAGE_NEW_ALL,
  GET_LOAD_IMAGE_NEW_BY,
  HEADERS_EXPORT_BEN,
  HEADERS_UPIMAGE,
  POST_RECEIVE_JOBS_ENFORCE,
} from "../../../API/apiUrls";
import { getFileType } from "../../contractDetail/contractDetailNew/utils";
import PdfPreviewModal from "../../contractDetail/contractDetailNew/components/PdfPreviewModal";
import AddImage from "../../contractDetail/modal/AddImage";

// ✅ แสดงเฉพาะ menuType/imageType ที่ยังใช้งานจริง (ที่ comment ปิดไว้ = เลิกใช้)
const getDocLabel = (menuType, imageType) => {
  // menuType 5 = คำฟ้อง
  if (menuType === 5 && imageType === 3)
    return { label: "ไฟล์คำฟ้อง", color: "#d46b08" }; // ส้มเข้ม
  // if (menuType === 5 && imageType === 4)
  //   return { label: "ใบเสร็จศาลคำฟ้อง", color: "#d46b08" }; // ส้มเข้ม
  // menuType 6 = ศาลตัดสิน
  if (menuType === 6 && imageType === 7)
    return { label: "คำพิพากษา", color: "#096dd9" }; // น้ำเงินเข้ม
  if (menuType === 6 && imageType === 8)
    return { label: "คำพิพากษา(ทำยอม)", color: "#096dd9" }; // น้ำเงินเข้ม
  if (menuType === 6 && imageType === 9)
    return { label: "ถอนฟ้อง", color: "#096dd9" }; // น้ำเงินเข้ม
  // if (menuType === 6 && imageType === 10)
  //   return { label: "ใบเสร็จศาลหลังพิพากษา", color: "#389e0d" }; // เขียวเข้ม
  if (menuType === 6 && imageType === 12)
    return { label: "วางคำบังคับ", color: "#096dd9" }; // น้ำเงินเข้ม
  // menuType 8 = ปิดบัญชี
  // if (menuType === 8 && imageType === 13)
  //   return { label: "ใบตัดจ่าย", color: "#096dd9" }; // น้ำเงินเข้ม
  // if (menuType === 8 && imageType === 14)
  //   return { label: "ใบเสร็จปิดบัญชี", color: "#096dd9" }; // น้ำเงินเข้ม
  if (menuType === 9 && imageType === 16)
    return { label: "หมายตั้ง", color: "#096dd9" }; // น้ำเงินเข้ม
  // return { label: "เอกสาร", color: "#595959" }; // เทาเข้ม
};

const formatThaiDate = (d) =>
  d ? dayjs(d).add(543, "year").format("DD/MM/YYYY") : "-";

// ── โซนเอกสาร ตรงกับ menuType ที่ loadPath ดึงมา (5, 6, 9) ─────
const ZONE_CONFIG = {
  5: {
    title: "เอกสารคำฟ้อง",
    color: "#d46b08",
    bg: "#fff7e6",
    border: "#ffd591",
  },
  6: {
    title: "เอกสารชั้นศาล",
    color: "#096dd9",
    bg: "#e6f4ff",
    border: "#91caff",
  },
  9: {
    title: "เอกสารหมายตั้ง",
    color: "#389e0d",
    bg: "#f6ffed",
    border: "#b7eb8f",
  },
};

// ── ประเภททรัพย์ ──────────────────────────────────────────────
const ASSET_TYPE_META = {
  1: { label: "ที่ดิน (สืบออนไลน์พบ)", color: "cyan", isLand: true },
  2: { label: "อายัดเงินได้", color: "gold" },
  3: { label: "รถนอกสัญญา", color: "purple", isVehicle: true },
  4: { label: "รถในสัญญา", color: "purple", isVehicle: true },
  5: { label: "ที่ดินในสัญญา", color: "cyan", isLand: true },
};
const getAssetTypeMeta = (typeAsset) =>
  ASSET_TYPE_META[typeAsset] || { label: "ไม่ระบุ", color: "default" };

const ZONE_GRADE_COLOR = { 1: "green", 2: "blue", 3: "orange", 4: "red" };

const UpdateEnforceDoc = ({ open, onCancel, dataDefault, onSuccess, geo }) => {
  const userId = parseInt(localStorage.getItem("USER_ID"));
  const token = localStorage.getItem("TOKEN");
  // const API_LINE_NOTI =
  //   "https://noti-lawyer-539174983798.asia-southeast1.run.app/api/notify/lawsuit/docs-complete";
  const API_LINE_NOTI =
    "  https://noti-lawyer-1024031113167.asia-southeast3.run.app/api/notify/lawsuit/docs-complete";

  const header = {
    "Content-Type": "application/json",
    "X-API-Key": "your-secret-key-here",
  };

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [fileListByContract, setFileListByContract] = useState([]);
  const [pdfPreviewOpen, setPdfPreviewOpen] = useState(false);
  const [pdfPreviewUrl, setPdfPreviewUrl] = useState("");
  const [isModalAddImge, setIsModalAddImge] = useState(false);

  const getProvinceDesc = useCallback(
    (provCode) => {
      if (provCode == null || provCode === "") return "-";
      const p = (geo?.province || []).find(
        (x) => String(x.provCode) === String(provCode),
      );
      return p?.provDesc || String(provCode);
    },
    [geo?.province],
  );

  const getDistrictDesc = useCallback(
    (distCode, provCode) => {
      if (distCode == null || distCode === "") return "-";
      const d = (geo?.district || []).find(
        (x) =>
          String(x.distCode) === String(distCode) &&
          (provCode == null || String(x.provCode) === String(provCode)),
      );
      return d?.distDesc || String(distCode);
    },
    [geo?.district],
  );

  const getAssetLocationText = useCallback(
    (a) =>
      `${getProvinceDesc(a.province)} ${getDistrictDesc(a.district, a.province)}`.trim(),
    [getProvinceDesc, getDistrictDesc],
  );

  // ✅ ปิด Modal และ Reset
  const handleClose = useCallback(() => {
    form.resetFields();
    onCancel?.();
  }, [form, onCancel]);

  // ✅ ส่งข้อมูล
  const sendStatus = async (data) => {
    try {
      const res = await axios.post(POST_RECEIVE_JOBS_ENFORCE, data, {
        headers: HEADERS_EXPORT_BEN,
      });

      if (res.status === 200) {
        return { success: true, status: res.status };
      } else {
        return { success: false, error: "ไม่สามารถส่งข้อมูลได้" };
      }
    } catch (error) {
      console.error("Error:", error);
      return {
        success: false,
        error:
          error.response?.data?.message || "เกิดข้อผิดพลาดในการอัพเดทข้อมูล",
      };
    }
  };

  // ✅ ส่งข้อมูล (docType: "enforce" = คำบังคับ, "summons" = หมายตั้ง)
  const sendNoti = async (docType) => {
    const docLabel = docType === "enforce" ? "คำบังคับ" : "หมายตั้ง";
    const payload = {
      case_no: dataDefault.newContno,
      case_name: dataDefault.SNAM + dataDefault.NAME1 + " " + dataDefault.NAME2,
      notify_to: [1, dataDefault.lawyerId],
      action_by: "ระบบ",
      message: `ผู้สืบทรัพย์ร้องขอเอกสาร${docLabel}\nเลขคดีแดง ${dataDefault.redCaseNumber}\nศาล ${dataDefault.provincialCourt}`,
    };

    try {
      const res = await axios.post(API_LINE_NOTI, payload, {
        headers: header,
      });

      if (res.status === 200) {
        message.success(`ส่งคำร้องขอ${docLabel}สำเร็จ`);
        return { success: true, status: res.status };
      } else {
        message.error("ไม่สามารถส่งข้อมูลได้");
        return { success: false, error: "ไม่สามารถส่งข้อมูลได้" };
      }
    } catch (error) {
      console.error("Error:", error);
      const errorMsg =
        error.response?.data?.message || "เกิดข้อผิดพลาดในการอัพเดทข้อมูล";
      message.error(errorMsg);
      return { success: false, error: errorMsg };
    }
  };

  const loadPath = useCallback(async () => {
    setLoading(true);
    try {
      const [imgRes5, imgRes6, imgRes9] = await Promise.all([
        axios.get(`${GET_LOAD_IMAGE_NEW_ALL}/5/${dataDefault.loanId}`, {
          headers: HEADERS_UPIMAGE,
        }),
        axios.get(`${GET_LOAD_IMAGE_NEW_ALL}/6/${dataDefault.loanId}`, {
          headers: HEADERS_UPIMAGE,
        }),
        axios.get(`${GET_LOAD_IMAGE_NEW_ALL}/9/${dataDefault.loanId}`, {
          headers: HEADERS_UPIMAGE,
        }),
      ]);

      const mapImg = (img) => ({
        ...img,
        CONTNO: dataDefault.CONTNO,
        loanId: dataDefault.loanId,
        lawsuitId: dataDefault.lawsuitId,
      });

      const allImages = [
        ...(imgRes5.data || []).map(mapImg),
        ...(imgRes6.data || []).map(mapImg),
        ...(imgRes9.data || []).map(mapImg),
      ];

      if (allImages.length === 0) {
        message.warning("ไม่พบรูปภาพ");
      }

      setFileListByContract(allImages);
    } catch (error) {
      console.error("Error loading data:", error);
      message.error(`เกิดข้อผิดพลาด: ${error.message}`);
      setFileListByContract([]);
    } finally {
      setLoading(false);
    }
  }, [dataDefault]);

  useEffect(() => {
    if (open) {
      loadPath();
    }
  }, [open, loadPath]);

  // ✅ เรียกใหม่หลังอัปโหลดรูปสำเร็จจาก AddImage
  const handleReload = () => {
    setFileListByContract([]);
    loadPath();
  };
  console.log("dataDefault", dataDefault);

  const onFinish = async (values) => {
    const postData = {
      userId: userId,
      idQueue: dataDefault.idQueue,
    };

    try {
      setLoading(true);

      const result = await sendStatus(postData);

      if (!result.success) {
        throw new Error(result.error);
      }

      message.success("อัพเดทข้อมูลสำเร็จ");

      setTimeout(() => {
        handleClose();
        onSuccess?.();
      }, 500);
    } catch (error) {
      console.error("❌ เกิดข้อผิดพลาด:", error);
      message.error(error.message || "เกิดข้อผิดพลาดในการบันทึกข้อมูล");
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = () => {
    message.error("กรุณากรอกข้อมูลที่มีเครื่องหมาย * ให้ครบ");
  };

  // ✅ แสดงเฉพาะเอกสารที่มี label (ไม่ใช่ประเภทที่ comment ปิดไว้) เรียงตาม menuType → imageType
  const sortedVisibleFiles = [...fileListByContract]
    .filter((file) => getDocLabel(file.menuType, file.imageType))
    .sort((a, b) =>
      a.menuType !== b.menuType
        ? a.menuType - b.menuType
        : a.imageType - b.imageType,
    );

  const zones = Object.keys(ZONE_CONFIG).map((menuType) => ({
    menuType: Number(menuType),
    files: sortedVisibleFiles.filter((f) => f.menuType === Number(menuType)),
  }));

  // ── card รูปภาพ ───────────────────────────────────────────────
  const renderImageCard = (file) => {
    const previewUrl = `${GET_LOAD_IMAGE_NEW_BY}/${file.path}?token=${token}`;
    const { label, color } = getDocLabel(file.menuType, file.imageType);

    return (
      <Col key={file.imageId} xs={8} sm={6} md={4}>
        <div
          style={{
            border: `1px solid ${color}`,
            borderRadius: 8,
            padding: 8,
            textAlign: "center",
            background: "#fff",
          }}
        >
          <Image
            src={previewUrl}
            alt={file.path}
            style={{
              width: "100%",
              height: 80,
              objectFit: "cover",
              borderRadius: 4,
            }}
            preview={{
              mask: (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  <EyeOutlined style={{ fontSize: 14 }} />
                  <span style={{ fontSize: 10 }}>ดูรูป</span>
                </div>
              ),
            }}
          />
          <div
            style={{
              marginTop: 6,
              background: color,
              color: "#fff",
              fontSize: 11,
              borderRadius: 4,
              padding: "1px 6px",
              display: "inline-block",
            }}
          >
            {label}
          </div>
        </div>
      </Col>
    );
  };

  // ── card PDF ──────────────────────────────────────────────────
  const renderPdfCard = (file) => {
    const previewUrl = `${GET_LOAD_IMAGE_NEW_BY}/${file.path}?token=${token}`;
    const { label, color } = getDocLabel(file.menuType, file.imageType);
    return (
      <Col key={file.imageId} xs={8} sm={6} md={4}>
        <div
          style={{
            border: `1px solid ${color}`,
            borderRadius: 8,
            padding: 8,
            textAlign: "center",
            background: "#fff",
          }}
        >
          <div
            onClick={() => {
              setPdfPreviewUrl(previewUrl);
              setPdfPreviewOpen(true);
            }}
            style={{
              cursor: "pointer",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: 80,
              background: "#fff1f0",
              borderRadius: 6,
              border: "1px dashed #ff4d4f",
              gap: 4,
              transition: "opacity 0.2s",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.7")}
            onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
          >
            <FilePdfOutlined style={{ fontSize: 32, color: "#ff4d4f" }} />
            <span style={{ fontSize: 11, color: "#ff4d4f", fontWeight: 500 }}>
              <EyeOutlined style={{ marginRight: 4 }} />
              ดู PDF
            </span>
          </div>
          <div
            style={{
              marginTop: 6,
              background: color,
              color: "#fff",
              fontSize: 11,
              borderRadius: 4,
              padding: "1px 6px",
              display: "inline-block",
            }}
          >
            {label}
          </div>
        </div>
      </Col>
    );
  };

  // ── กล่องโซนเอกสารตาม menuType ─────────────────────────────────
  const renderZone = ({ menuType, files }) => {
    if (!files.length) return null;
    const cfg = ZONE_CONFIG[menuType];
    const pdfFiles = files.filter((f) => getFileType(f.path) === "pdf");
    const imgFiles = files.filter((f) => getFileType(f.path) === "image");

    return (
      <div
        key={menuType}
        style={{
          border: `1px solid ${cfg.border}`,
          borderRadius: 10,
          padding: "12px 16px",
          marginBottom: 16,
          background: cfg.bg,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            marginBottom: 12,
            paddingBottom: 8,
            borderBottom: `1px solid ${cfg.border}`,
          }}
        >
          <div
            style={{
              background: cfg.color,
              color: "#fff",
              borderRadius: 6,
              padding: "2px 12px",
              fontSize: 14,
              fontWeight: 700,
            }}
          >
            {cfg.title}
          </div>
          <span style={{ fontSize: 14, color: "#888" }}>
            {files.length} ไฟล์
          </span>
        </div>

        {imgFiles.length > 0 && (
          <>
            <div style={{ fontSize: 14, color: "#888", marginBottom: 6 }}>
              รูปภาพ ({imgFiles.length})
            </div>
            <Image.PreviewGroup>
              <Row
                gutter={[8, 8]}
                style={{ marginBottom: pdfFiles.length ? 12 : 0 }}
              >
                {imgFiles.map(renderImageCard)}
              </Row>
            </Image.PreviewGroup>
          </>
        )}

        {pdfFiles.length > 0 && (
          <>
            <div
              style={{
                fontSize: 14,
                color: "#888",
                marginBottom: 6,
                marginTop: imgFiles.length ? 4 : 0,
              }}
            >
              <FilePdfOutlined style={{ color: "#ff4d4f", marginRight: 4 }} />
              เอกสาร PDF ({pdfFiles.length})
            </div>
            <Row gutter={[8, 8]}>{pdfFiles.map(renderPdfCard)}</Row>
          </>
        )}
      </div>
    );
  };

  // ── ตารางทรัพย์ (dataDefault.assets) ───────────────────────────
  const assetList = dataDefault?.assets || [];

  const assetColumns = [
    {
      title: "ลำดับ",
      key: "i",
      align: "center",
      width: 50,
      render: (_, __, i) => i + 1,
    },
    {
      title: "ประเภททรัพย์",
      key: "type",
      align: "center",
      width: 160,
      render: (_, a) => {
        const meta = getAssetTypeMeta(a.typeAsset);
        return (
          <Tag
            color={meta.color}
            icon={
              meta.isLand ? (
                <HomeOutlined />
              ) : meta.isVehicle ? (
                <CarOutlined />
              ) : undefined
            }
          >
            {meta.label}
          </Tag>
        );
      },
    },
    {
      title: "รายละเอียดทรัพย์",
      key: "detail",
      align: "left",
      render: (_, a) => {
        const meta = getAssetTypeMeta(a.typeAsset);
        if (meta.isLand) {
          return (
            <div style={{ fontSize: 13, lineHeight: 1.7 }}>
              <div>
                <span style={{ color: "#888" }}>เลขที่ดิน </span>
                <strong>{a.numberLand || "-"}</strong>
                {a.numberLandlawang && (
                  <span style={{ color: "#888" }}>
                    {" "}
                    (ระวาง {a.numberLandlawang})
                  </span>
                )}
              </div>
              <div style={{ color: "#888" }}>{getAssetLocationText(a)}</div>
            </div>
          );
        }
        if (meta.isVehicle) {
          return (
            <div style={{ fontSize: 13, lineHeight: 1.7 }}>
              <div>
                <strong>
                  {`${a.vhType || ""} ${a.vhModel || ""}`.trim() || "-"}
                </strong>
                {a.vhColor && (
                  <span style={{ color: "#888" }}> สี{a.vhColor}</span>
                )}
              </div>
              <div style={{ color: "#888" }}>
                ทะเบียน {a.vhLicensePlate || "-"} ({a.vhRegProvince || "-"}) ・
                เลขตัวถัง {a.vhChassisNo || "-"}
              </div>
            </div>
          );
        }
        return (
          <div>
            {a.assetValue != null ? a.assetValue.toLocaleString() : "-"}
          </div>
        );
      },
    },
    {
      title: "โซน",
      key: "zoneGrade",
      align: "center",
      width: 80,
      render: (_, a) =>
        a.zoneGrade != null ? (
          <Tag color={ZONE_GRADE_COLOR[a.zoneGrade] || "default"}>
            {a.zoneGrade}
          </Tag>
        ) : (
          "-"
        ),
    },
    {
      title: "ผลลงพื้นที่",
      key: "onsite",
      align: "center",
      width: 150,
      render: (_, a) => (
        <div>
          <Tag color={a.flagOnsite ? "green" : "default"}>
            {a.flagOnsite ? "ลงพื้นที่แล้ว" : "ยังไม่ลงพื้นที่"}
          </Tag>
          {a.dateOnsite && (
            <div style={{ fontSize: 12, color: "#888" }}>
              {formatThaiDate(a.dateOnsite)}
            </div>
          )}
        </div>
      ),
    },
  ];

  // ✅ แสดงชื่อเจ้าของสัญญา
  const ownerName = dataDefault
    ? `${dataDefault.newContno || ""} / ${dataDefault.SNAM || ""}${
        dataDefault.NAME1 || ""
      } ${dataDefault.NAME2 || ""}`.trim()
    : "-";

  return (
    <Modal
      title="รับงานสืบทรัพย์"
      open={open}
      onCancel={handleClose}
      width={850}
      footer={null}
      destroyOnHidden
    >
      <Spin spinning={loading} size="large" tip="กำลังบันทึก...">
        <Card>
          <Form
            form={form}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 14 }}
            layout="horizontal"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
          >
            <Form.Item label="เลขสัญญา/เจ้าของสัญญา">
              <span style={{ fontWeight: 500 }}>{ownerName}</span>
            </Form.Item>

            <Form.Item label="ศาล">{dataDefault?.provincialCourt}</Form.Item>

            <Form.Item label="หมายเลขคดีแดง">
              {dataDefault?.redCaseNumber}
            </Form.Item>
            <Form.Item label="วันที่พิพากษา">
              {formatThaiDate(dataDefault?.judgeDate)}
            </Form.Item>
            <Form.Item label="คำบังคับ">
              <div>
                <Tag color={dataDefault?.enforceCaseDate ? "green" : "default"}>
                  {dataDefault?.enforceCaseDate ? "อัพแล้ว" : "ยังไม่อัพ"}
                </Tag>
                <span style={{ color: "#888" }}>
                  {formatThaiDate(dataDefault?.enforceCaseDate)}
                </span>
              </div>
            </Form.Item>
            <Form.Item label="หมายตั้ง">
              <div>
                <Tag color={dataDefault?.docDate ? "green" : "default"}>
                  {dataDefault?.docDate ? "อัพแล้ว" : "ยังไม่อัพ"}
                </Tag>
                <span style={{ color: "#888" }}>
                  {formatThaiDate(dataDefault?.docDate)}
                </span>
              </div>
            </Form.Item>

            <Divider orientation="left" style={{ marginTop: 24 }}>
              <HomeOutlined /> ทรัพย์ ({assetList.length} รายการ)
            </Divider>

            {assetList.length > 0 ? (
              <Table
                size="small"
                columns={assetColumns}
                dataSource={assetList}
                rowKey={(a) => a.idAsset ?? a.assetKey}
                pagination={false}
                style={{ marginBottom: 8 }}
              />
            ) : (
              <Empty
                description="ไม่พบข้อมูลทรัพย์"
                style={{ margin: "16px 0" }}
              />
            )}

            <Divider orientation="left" style={{ marginTop: 24 }}>
              <FileSearchOutlined /> เอกสาร
            </Divider>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginBottom: 12,
              }}
            >
              <Button
                icon={<UploadOutlined />}
                type="primary"
                ghost
                onClick={() => setIsModalAddImge(true)}
              >
                อัปโหลดรูป/ไฟล์
              </Button>
            </div>

            {sortedVisibleFiles.length > 0 ? (
              zones.map(renderZone)
            ) : (
              <Empty description="ไม่มีเอกสาร" style={{ margin: "24px 0" }} />
            )}

            <div style={{ display: "flex", justifyContent: "center" }}>
              <Space>
                <Button onClick={handleClose} danger>
                  ยกเลิก
                </Button>
                <Button
                  variant="outlined"
                  color="orange"
                  onClick={() => sendNoti("enforce")}
                >
                  ร้องขอคำบังคับ
                </Button>
                <Button
                  variant="outlined"
                  color="blue"
                  onClick={() => sendNoti("summons")}
                >
                  ร้องขอหมายตั้ง
                </Button>
                {!dataDefault.receiveDate && (
                  <Button variant="outlined" color="green" htmlType="submit">
                    รับงาน
                  </Button>
                )}
              </Space>
            </div>
          </Form>
        </Card>
      </Spin>

      <PdfPreviewModal
        open={pdfPreviewOpen}
        url={pdfPreviewUrl}
        onClose={() => {
          setPdfPreviewOpen(false);
          setPdfPreviewUrl("");
        }}
      />

      {isModalAddImge && (
        <AddImage
          open={isModalAddImge}
          close={() => setIsModalAddImge(false)}
          dataDefault={{ judge: [dataDefault] }}
          onSuccess={handleReload}
        />
      )}
    </Modal>
  );
};

export default UpdateEnforceDoc;
